var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectedLightFitting01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.02,14.47c-3.03-0.29-5.34-2.86-5.3-5.86c0-2.9,2.37-5.27,5.27-5.27c2.91,0,5.27,2.37,5.27,5.27 C13.32,11.61,11.01,14.19,8.02,14.47z M8,3.84c-2.63,0-4.77,2.14-4.77,4.77c-0.04,2.75,2.07,5.1,4.8,5.36 c2.68-0.26,4.79-2.61,4.75-5.35v0C12.77,5.99,10.63,3.84,8,3.84z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.96,3.85 9.46,3.85 9.46,2.42 6.54,2.42 6.54,3.85 6.04,3.85 6.04,1.92 9.96,1.92  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectedLightFitting01);
export default __webpack_public_path__ + "static/media/ProtectedLightFitting-01.f4128cfbcc3cfc5ebc8d83f88ead15c3.svg";
export { ForwardRef as ReactComponent };